import { render, staticRenderFns } from "./ModalDocumentos.vue?vue&type=template&id=733e1d4c"
import script from "./ModalDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentos.vue?vue&type=style&index=0&id=733e1d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports